import {
	Avatar,
	Badge,
	Box,
	Checkbox,
	Chip,
	ClickAwayListener,
	FormControlLabel,
	List,
	ListItem,
	ListItemText,
	MenuItem,
	MenuList,
	Paper,
	Popper,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
} from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { getUserName } from '../../../config/utils';
import { OKRButton } from '../../Common/OKRButton';
import { RecommendedIcon } from '../../../config/svg/CommonSvgIcon';
import { ConversationIcon } from '../../../config/svg/CommonSvg';
import { setPerformanceReviewDrUserData, setPerformanceSelfReviewDrUserData } from '../../../action/adminSettings';
import { useDispatch } from 'react-redux';
import { BorderCheckboxIcon, CheckedIcon } from '../../../config/svg/formElementIcons';

export const TeamReviewData = (props: any) => {
	const {
		users,
		handleSettingsDrawerOpen,
		t,
		index,
		onUserSelect,
		fromApproval,
		teamReviewUserListResponse,
		allowOnlyWorkflowId,
	} = props;
	const [openTeamMenu, setOpenTeamMenu] = useState<boolean>(false);
	const [anchorElTeam, setAnchorElTeam] = useState<HTMLElement | null>(null);
	const [openRecommendPopup, setOpenRecommendPopup] = useState<boolean>(false);
	const [anchorElRecommend, setAnchorElRecommend] = useState<HTMLElement | null>(null);

	const dispatch = useDispatch();
	const handleOpenTeam = (event: any) => {
		setAnchorElTeam(event.currentTarget);
		setOpenTeamMenu(true);
	};
	const handleCloseTeam = (event: any) => {
		setAnchorElTeam(null);
		setOpenTeamMenu(false);
	};
	const handleOpenRecommendPopup = (event: any) => {
		setAnchorElRecommend(event.currentTarget);
		setOpenRecommendPopup(true);
	};
	const handleCloseRecommendPopup = (event: any) => {
		setAnchorElRecommend(null);
		setOpenRecommendPopup(false);
	};
	const giveReview = (data: any) => {
		dispatch(
			setPerformanceSelfReviewDrUserData({
				...data,
				fromManager: true,
				fromApproval: fromApproval,
				teamReviewUserListResponse: teamReviewUserListResponse,
			})
		);
	};
	const goToUserReview = (data: any) => {
		dispatch(setPerformanceReviewDrUserData({ ...data, teamReviewUserListResponse: teamReviewUserListResponse }));
	};

	return (
		<>
			<Fragment key={`permission${1}`}>
				<TableRow className={'team-review-table-row'}>
					<TableCell className='user-col1'>
						<Box className='cell-wrap'>
							{fromApproval && (
								<FormControlLabel
									control={
										<Checkbox
											icon={<BorderCheckboxIcon />}
											checkedIcon={<CheckedIcon />}
											name={'list' + index}
											checked={users?.isChecked === undefined ? false : users?.isChecked}
											onChange={(e: any) => onUserSelect(e, index)}
											key={index}
											// disabled={
											// 	users.isPerformanceCycleDone ||
											// 	!users.isCheckboxEnable ||
											// 	(users?.isManagerAssessmentCompleted &&
											// 		users?.managerAssessmentScore &&
											// 		users.finalRatingId > 0) ||
											// 	(allowOnlyWorkflowId !== 0 && allowOnlyWorkflowId !== users.performanceGoalReviewWorkFlowTypeId)
											// }
											disabled={!users.isCheckboxEnable}
										/>
									}
									label=''
								/>
							)}
							<Box className='user-info v-center'>
								<Box className='user-img'>
									<Avatar className='avatar-default' key={`user-icon-${users.employeeId}`} src={users.imagePath || ''}>
										{getUserName({
											firstName: users.firstName || '',
											lastName: users.lastName || '',
											fullName: users.firstName + ' ' + users.lastName || '',
										})}
									</Avatar>
								</Box>
								<Box className='user-info-details'>
									<Tooltip arrow title={users.firstName + ' ' + users.lastName}>
										<Typography>{users.firstName + ' ' + users.lastName || ''}</Typography>
									</Tooltip>
								</Box>
							</Box>
						</Box>
					</TableCell>
					<TableCell className='user-col2'>
						<Box className='cell-wrap'>
							<Tooltip arrow title={users.teamName}>
								<Typography>{users.teamName}</Typography>
							</Tooltip>
							{users.employeeTeamDetails.length - 1 > 0 && (
								<Box
									className='other-teams-chip'
									aria-owns={openTeamMenu ? 'mouse-over-popover' : undefined}
									aria-haspopup='true'
									onMouseOver={handleOpenTeam}
									onMouseLeave={handleCloseTeam}
								>
									<Typography variant='body2'>{users.employeeTeamDetails.length - 1}</Typography>
									<Popper
										className='popper-menu-list team-filter-list-menu'
										transition
										open={openTeamMenu}
										anchorEl={anchorElTeam}
										placement='bottom-start'
									>
										<Paper>
											<ClickAwayListener onClickAway={handleCloseTeam}>
												<MenuList id={`team-review-team-list`}>
													{users.employeeTeamDetails.length > 0 &&
														users.employeeTeamDetails.map((item: any, index: number) => (
															<>
																{index > 0 && (
																	<MenuItem key={item?.teamId} id={`team-name-${item?.teamId}-${index}`}>
																		<ListItemText
																			primary={
																				<>
																					{item?.teamName && item?.teamName.length > 25 ? (
																						<Tooltip arrow title={item?.teamName} aria-label='Teams'>
																							<Typography variant='h5' className='team-filter-txt'>
																								{item?.teamName.substring(0, 25)}...
																							</Typography>
																						</Tooltip>
																					) : (
																						<Typography>{item?.teamName}</Typography>
																					)}
																				</>
																			}
																		/>
																	</MenuItem>
																)}
															</>
														))}
												</MenuList>
											</ClickAwayListener>
										</Paper>
									</Popper>
								</Box>
							)}
						</Box>
					</TableCell>
					<TableCell className='user-col3'>
						<Box className='cell-wrap'>
							<Typography
								className={`font-weight-bold ${users.selfFinalRatingId > 0 ? 'cursor-pointer clickable-text' : ''}`}
								onClick={() => {
									if (users.selfFinalRatingId) {
										goToUserReview(users);
									}
								}}
							>
								{users.selfReviewStatus}
							</Typography>
							<Typography variant='body2' className='font-weight-normal'>
								{users.selfFinalRatingId > 0 && users.selfFinalRating}
							</Typography>
						</Box>
					</TableCell>
					<TableCell className='user-col4'>
						<Box className='cell-wrap'>
							{users.managerReviewStatus && (
								<OKRButton
									className='btn-link-type1'
									disabled={!users.isManagerClickable || users.isCycleCompleted}
									text={users.managerReviewStatus}
									handleClick={() => {
										giveReview(users);
									}}
								/>
							)}
							{users.finalRatingId > 0 && (
								<Box className='manager-review-status'>
									<Typography variant='body2' className='font-weight-normal'>
										{users.selfFinalRatingId > 0 && users.managerFinalRating}
									</Typography>
									<Box
										className=''
										aria-owns={openRecommendPopup ? 'mouse-over-popover' : undefined}
										aria-haspopup='true'
									>
										<OKRButton
											handleClick={handleOpenRecommendPopup}
											className='recommended-btn'
											icon={<RecommendedIcon />}
										/>
										<Popper
											className='recommend-popper'
											transition
											open={openRecommendPopup}
											anchorEl={anchorElRecommend}
											placement='bottom'
										>
											<Paper>
												<ClickAwayListener onClickAway={handleCloseRecommendPopup}>
													<Box className='recommend-popup-content'>
														<List disablePadding>
															<ListItem>
																<span>{t('recommendedTrainings')}:</span>
																{users?.recommendedTrainingCount ? users?.recommendedTrainingCount + ' ' : ''}
																{users?.recommendedTrainingCount && users?.otherTrainings ? 'and' + ' ' : ''}
																{users?.otherTrainings ? t('otherTrainings') : ''}
															</ListItem>
															<ListItem>
																<span>{t('salaryIncrement')}:</span>
																{users?.eligibleForSalaryIncrement ? t('yesLabel') : t('noLabel')}{' '}
																{users?.salaryIncrement ? '(' + users?.salaryIncrement + '%)' : ''}
															</ListItem>

															<ListItem>
																<span>{t('promotionLabel')}:</span>
																{users?.eligibleForPromotion ? t('yesLabel') : t('noLabel')}{' '}
																{users?.promotionDesignation ? '(' + users?.promotionDesignation + ')' : ''}
															</ListItem>
															<ListItem>
																<span>{t('commentsText')}:</span>
																<span
																	dangerouslySetInnerHTML={{
																		__html: users?.finalComment ? users?.finalComment : '',
																	}}
																></span>
															</ListItem>
														</List>
													</Box>
												</ClickAwayListener>
											</Paper>
										</Popper>
									</Box>
								</Box>
							)}
						</Box>
					</TableCell>
					<TableCell className='user-col5'>
						<Box className='cell-wrap'>
							<Typography variant='body2' className='font-weight-normal'>
								{users.performanceGoalReviewWorkFlowType}
							</Typography>
							<Box className='team-review-status'>
								{
									<Chip
										className={users.statusName === 'Publish' ? 'on-track-chip' : 'lagging-chip'}
										label={users.statusName}
									/>
								}
							</Box>
						</Box>
					</TableCell>
					<TableCell className='user-col6'>
						<Box className='cell-wrap'>
							<Typography>
								<OKRButton
									className={`conversation-btn`}
									wrapClassName={'conversation-btn-wrap'}
									icon={
										<Badge
											variant='dot'
											className='dot-bubble'
											overlap='circular'
											invisible={!users.isConversationRedDotAlert ? true : false}
										>
											<ConversationIcon />
										</Badge>
									}
									title={t('reviewConversation')}
									handleClick={(event: any) => handleSettingsDrawerOpen(event, users, 'conversation')}
								/>
							</Typography>
						</Box>
					</TableCell>
				</TableRow>
			</Fragment>
		</>
	);
};
